import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { showSplashScreen } from './util/SplashScreen';
import { Capacitor } from '@capacitor/core';

declare global {
  var relogin: boolean;
};

// Force-clear any existing service worker cache on native platforms
// so stale cached web assets are never served inside the WebView.
if (Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
  caches.keys().then((cacheNames) => {
    cacheNames.forEach((cacheName) => caches.delete(cacheName));
  });
}

showSplashScreen({ autoHide: false, fadeInDuration: 750 }).then(() => {
  // Call the element loader after the platform has been bootstrapped
  defineCustomElements(window);
  
  //initialize global variable
  globalThis.relogin = false;

    const container = document.getElementById('root');
    const root = createRoot(container!);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://cra.link/PWA
    if (Capacitor.isNativePlatform()) {
      serviceWorkerRegistration.unregister();
    } else {
      serviceWorkerRegistration.register();
    }

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
});